import { BroadcastStatus } from '../../../common/enums/BroadcastStatus';
import type { StatusBadgeVariant } from '../../Shared/StatusBadge/StatusBadge';

/**
 * Returns the StatusBadge variant for a broadcast status
 */
export const getBroadcastStatusVariant = (
  status: BroadcastStatus
): StatusBadgeVariant => {
  switch (status) {
    case BroadcastStatus.NEW:
      return 'info';
    case BroadcastStatus.SCHEDULING:
      return 'info';
    case BroadcastStatus.IN_PROGRESS:
      return 'warning';
    case BroadcastStatus.COMPLETED:
      return 'success';
    case BroadcastStatus.FAILED:
      return 'error';
    default:
      return 'neutral';
  }
};

/**
 * Calculates percentage rate with 2 decimal places
 */
export const calculatePercentage = (
  numerator: number,
  denominator: number
): string => {
  if (denominator === 0) return '0';
  return ((numerator / denominator) * 100).toFixed(2);
};

/**
 * Calculates delivery rate (received / total users)
 */
export const calculateDeliveryRate = (
  received: number,
  total: number
): string => {
  return calculatePercentage(received, total);
};

/**
 * Calculates click-through rate (clicked / received)
 */
export const calculateClickThroughRate = (
  clicked: number,
  received: number
): string => {
  return calculatePercentage(clicked, received);
};

/**
 * Calculates batch progress percentage (completed batches / total batches)
 */
export const calculateBatchProgress = (
  sent: number,
  failed: number,
  total: number
): number => {
  if (total === 0) return 0;
  return ((sent + failed) / total) * 100;
};
